import "./component-cart-item.scss";
import { html } from "lit";
import ComponentBase from "./component-base";
import { property } from "lit/decorators.js";
import { FormatPrice } from "../assets/js/libs/utils";
import { ProductDto } from "../model/dtos";
class CartItem extends ComponentBase {
  static get tagName() {
    return "ncx-cart-item";
  }

  @property()
  item;
  @property()
  index: number;
  @property()
  OnQtyChange: (e: Event, index: number) => void;
  @property()
  OnQtyBlur: (e: Event, index: number) => void;
  @property()
  OnQtyClick: (e: Event, index: number) => void;
  @property()
  OnIncreaseQty: (e: Event, index: number) => void;
  @property()
  OnDecreaseQty: (e: Event, index: number) => void;
  @property()
  OnRemoveItem: (index: number, quantity: number) => void;

  getPrice(item: ProductDto) {
    let price = item.price;
    if (item.customizations)
      item.customizations.forEach((c) =>
        c.customizations.forEach((cc) => (price += cc.price))
      );
    return FormatPrice().format(price);
  }

  protected render(): unknown {
    return html`
      <div>
        <div class="mb-2">
          <div class="fw-bold">${this.item.name}</div>
          <div>
            ${this.item.customizations?.map((customization) =>
              customization.customizations.map(
                (cc) => html`<div>${cc.name}</div>`
              )
            )}
          </div>
        </div>
        <div class="mb-2 d-flex justify-content-between align-items-center">
          <span>${this.getPrice(this.item)}</span>&times;
          <span class="quantity-control d-flex align-items-center">
            <button
              @click=${(e) => this.OnDecreaseQty(e, this.index)}
              type="button"
              class="btn btn-outline-secondary"
            >
              <i class="bi bi-dash"></i>
            </button>
            <input
              min="1"
              class="form-control"
              name="qty"
              .value=${this.item.quantity}
              type="text"
              readonly
              @change=${(e) => this.OnQtyChange(e, this.index)}
              @input=${(e) => this.OnQtyChange(e, this.index)}
              @blur=${(e) => this.OnQtyBlur(e, this.index)}
              @click=${(e) => this.OnQtyClick(e, this.index)}
            />
            <button
              @click=${(e) => this.OnIncreaseQty(e, this.index)}
              type="button"
              class="btn btn-outline-secondary"
            >
              <i class="bi bi-plus"></i>
            </button>
          </span>
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <button
              @click=${() => this.OnRemoveItem(this.index, this.item.quantity)}
              type="button"
              class="btn btn-outline-danger"
            >
              <i class="bi bi-trash"></i>
            </button>
          </div>
          <div>
            <!--button @click=${() => {}} type="button" class="btn btn-outline-secondary">
                                          <i class="bi bi-pencil"></i>
                                      </button-->
          </div>
        </div>
      </div>
    `;
  }
}
CartItem.Register();
export default CartItem;
